import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { debounceTime } from 'rxjs';
import { AppToastComponent } from '../components/app-toast/app-toast.component';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { GlobalBannerService } from '../services/global-banner.service';
import { LoadingService } from '../services/loading.service';
import { HeaderComponent } from './header/header.component';
import { QbButtonComponent } from './quickbooks/qb-button/qb-button.component';
import { IsConnectedStatus } from './quickbooks/quickbooks.service';
import { QuickbooksStore } from './quickbooks/quickbooks.store';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'app-pages',
  imports: [
    HeaderComponent,
    SidebarComponent,
    RouterOutlet,
    AppToastComponent,
    CommonModule,
    QbButtonComponent,
    ConfirmationDialogComponent,
    SpinnerComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit {
  readonly store = inject(QuickbooksStore);
  public qbStatus$ = toObservable(this.store.connectionStatus).pipe(debounceTime(300));
  public IsConnectedStatus = IsConnectedStatus;

  // Additional flags for message visibility
  public disconnectedMessageClosed = false;
  public get showConnectedMessage(): boolean {
    return this.store.connectionStatus() === IsConnectedStatus.connected;
  }

  protected isLoading$ = inject(LoadingService).loading$;
  private bannerService = inject(GlobalBannerService);
  public banner = this.bannerService.banner;
  ngOnInit(): void {
    this.store.load();
  }

  public dismissBanner() {
    this.bannerService.clear();
  }
}
